<template>
  <div>
    <slot name='extra-buttons'></slot>
    <v-btn
      v-if='!hideEdit'
      x-small
      icon
      color='orange'
      :disabled='disableEdit'
       @click="$emit('edit')"
    >
      <v-icon small color='orange'>
        mdi-pencil
      </v-icon>
    </v-btn>
    <v-btn
      v-if='!hideSortUp'
      x-small
      icon
      color='info'
      :disabled='disableSortUp'
      @click="$emit('sortUp')"
    >
      <v-icon small color='info'>
        mdi-upload
      </v-icon>
    </v-btn>
    <v-btn
      v-if='!hideSortDown'
      x-small
      icon
      color='info'
      :disabled='disableSortDown'
      @click="$emit('sortDown')"
    >
      <v-icon small color='info'>
        mdi-download
      </v-icon>
    </v-btn>
    <v-btn
      v-if='!hideDelete'
      x-small
      icon
      color='red'
      @click="$emit('deleteLine')"
      :class="hideSortUp || hideSortDown ? 'ml-3' : ''"
    >
      <v-icon small color='red'>
        mdi-delete
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
/*
When using this component, all buttons will show by default
To add additional buttons in the slot, the buttons and icons must have this form:

  <v-btn x-small icon>

Make sure they have the `x-small` and `icon` props

Then, internal icon element must have the `small` prop:

  <v-icon small>

*/
export default {
  name: 'wc-line-actions',
  props: {
    hideEdit: {
      required: false,
      type: Boolean,
      default: false
    },
    hideSortUp: {
      required: false,
      type: Boolean,
      default: false
    },
    hideSortDown: {
      required: false,
      type: Boolean,
      default: false
    },
    disableEdit: {
      required: false,
      default: false
    },
    disableSortUp: {
      required: false,
      default: false
    },
    disableSortDown: {
      required: false,
      default: false
    },
    hideDelete: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
